export default "__VITE_ASSET__DdbY2Vjo__"